import { Button } from '@/components/Button';
import { Card } from '@/components/Card';
import { CodeField } from '@/components/CodeField';
import { Form } from '@/components/Form';
import { Flex } from '@/components/Grid';
import { Heading } from '@/components/Heading';
import { Text } from '@/components/Text';
import { verifyCode, login, getAccount } from '@/resource/account';
import { SetState } from '@/util/types';
import { useState } from 'react';

type Props = {
  isActive: boolean;
  hasSoftKeyboard: boolean;
  isValid: boolean;
  code: string;
  email: string;
  password: string;
  digits: string[];
  setDigits: SetState<string[]>;
  onNext: () => void;
};

export function Step4({
  isActive,
  hasSoftKeyboard,
  isValid,
  code,
  email,
  digits,
  setDigits,
  password,
  onNext,
}: Props) {
  const [error, setError] = useState('');
  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        setError('');
        verifyCode({ code, email }).then((res) => {
          if (res.type === 'ok') {
            login({ email, password })
              .then(() => getAccount().then(onNext))
              .catch((err) => console.error(err));
          } else if (res.type === 'catch') {
            switch (res.data.reason) {
              case 'expired':
                return setError('Deze code is verlopen.');
              case 'invalid_code':
                return setError('Deze code is ongeldig.');
              case 'too_many_attempts':
                return setError(
                  'Je hebt teveel pogingen gedaan. De code is nu verlopen.'
                );
              case 'unauthorized':
                return setError('Je profiel kon niet gevonden worden.');
            }
          }
        });
      }}
    >
      <Flex dir="column" gap={4}>
        <Heading align="center">Code uit mail</Heading>
        <Card>
          <CodeField
            digits={digits}
            setDigits={setDigits}
            autoFocus={isActive && !hasSoftKeyboard}
          />
        </Card>

        {error.length > 0 && (
          <Text balance align="center" theme="error">
            {error}
          </Text>
        )}

        <Flex justify="end">
          <Button
            type="submit"
            disabled={!isValid}
            icon="chevron_right_narrow"
            iconSize={2}
            iconPosition="right"
          >
            Check code
          </Button>
        </Flex>
      </Flex>
    </Form>
  );
}
